import type { SVGProps } from 'react';

const SvgHomeMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M11.3291 4.31641C11.7386 4.05584 12.2614 4.05584 12.6709 4.31641L19.6709 8.77051C20.0315 8.99996 20.25 9.39782 20.25 9.8252V19C20.25 19.6904 19.6904 20.25 19 20.25H5C4.30964 20.25 3.75 19.6904 3.75 19V9.8252C3.75 9.39782 3.96854 8.99996 4.3291 8.77051L11.3291 4.31641Z'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M8 16H16' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' />
  </svg>
);
export default SvgHomeMd;
